// The seen report. Impressions are the only metric a pop-up has — it cannot be replied to or
// clicked — so "seen" is the column everything else is read against.
import React from 'react';
import { campaignName, formatLabel, isLive, num, reachPct, shortDate } from './format';

const Campaigns = ({ campaigns, onEnd, onEdit, onDelete, busyId, editingId }) => (
  <div className="card hist-card">
    <h3>Campaigns · seen report</h3>
    <table className="hist">
      <thead>
        <tr>
          <th>Campaign</th>
          <th>Format</th>
          <th>Status</th>
          <th className="num">Seen</th>
          <th className="num">Unique</th>
          <th>Reach</th>
          <th>Ends</th>
          <th aria-label="Actions" />
        </tr>
      </thead>
      <tbody>
        {/* `null` until the first load answers. Saying "no campaigns yet" while the request is
            still out — or after it failed — is the difference between an empty page and a lie. */}
        {campaigns === null && (
          <tr><td className="empty" colSpan={8}>Loading campaigns…</td></tr>
        )}
        {campaigns?.length === 0 && (
          <tr><td className="empty" colSpan={8}>No campaigns yet — the first one you launch shows here.</td></tr>
        )}
        {(campaigns || []).map((c) => {
          const live = isLive(c);
          const pct = reachPct(c);
          return (
            <tr key={c._id}>
              <td>
                {c.image && c.format !== 'text' && <img className="hist-thumb" src={c.image} alt="" />}
                {campaignName(c)}
              </td>
              <td>
                <span className={`fmt ${c.format !== 'text' ? 'img' : ''}`}>{formatLabel(c.format)}</span>
                {c.placement === 'sheet' && <span className="fmt sheet">Sheet</span>}
              </td>
              <td><span className={`status ${live ? 'live' : 'ended'}`}>{live ? 'Live' : 'Ended'}</span></td>
              <td className="num">{num(c.seen)}</td>
              <td className="num">{num(c.unique)}</td>
              <td>
                {pct}%
                <span className="seenbar"><i style={{ width: `${pct}%` }} /></span>
              </td>
              <td>{shortDate(c.endsAt)}</td>
              <td className="num">
                <span className="row-acts">
                  <button
                    type="button"
                    className={`tmpl-tgl ${editingId === c._id ? 'on' : ''}`.trim()}
                    disabled={busyId === c._id}
                    onClick={() => onEdit(c)}
                  >
                    {editingId === c._id ? 'Editing' : 'Edit'}
                  </button>
                  {live && (
                    <button
                      type="button"
                      className="tmpl-tgl"
                      disabled={busyId === c._id}
                      onClick={() => onEnd(c)}
                    >
                      End now
                    </button>
                  )}
                  {/* Confirmed here rather than with a modal: it is irreversible and it takes the
                      seen report with it, so the count is what the question has to name. */}
                  <button
                    type="button"
                    className="tmpl-tgl danger"
                    disabled={busyId === c._id}
                    onClick={() => {
                      const seen = num(c.seen);
                      if (window.confirm(`Delete this campaign and its ${seen} impressions? This cannot be undone.`)) {
                        onDelete(c);
                      }
                    }}
                  >
                    Delete
                  </button>
                </span>
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  </div>
);

export default Campaigns;
